import {
    Step,
    StepConnector,
    StepIcon,
    StepLabel,
    Stepper,
    styled
} from '@mui/material';
import { I18nStore } from '@tools/i18n/store';
import { injectTSDI } from '@tools/tsdi';
import { observer } from 'mobx-react';
import * as React from 'react';

import { SignupStore } from '../../signup-store';
import { stepsContent } from '../../steps-data';

interface StyledStepIconProps {
    completed?: boolean;
    active?: boolean;
}

const StyledStepper = styled(Stepper)({
    padding: '24px 0 40px 0',
    alignItems: 'stretch'
});

const StyledStep = styled(Step)({
    padding: 0,
    '&:first-of-type + div > span': {
        left: 0,
        right: 'auto'
    }
});

const CustomStepIcon = styled(StepIcon)<StyledStepIconProps>(
    ({ theme, active }) => ({
        '&.MuiStepIcon-root.Mui-active': {
            width: '1.2em',
            height: '1.2em'
        },
        '&.Mui-completed': {
            color: theme.palette.secondary.main
        },
        '.MuiStepIcon-text': {
            fontWeight: active ? 'bold' : 'normal'
        }
    })
);

const CustomStepConnector = styled(StepConnector)({
    position: 'relative',
    height: '100%',
    '.MuiStepConnector-line': {
        position: 'absolute',
        width: 'calc(100% + 20px)',
        top: 12,
        right: 0
    }
});

const StyledStepLabel = styled(StepLabel)(({ theme }) => ({
    flexDirection: 'column',
    '.MuiStepLabel-iconContainer': {
        paddingBottom: theme.spacing(1)
    },
    '.Mui-active.MuiStepLabel-label': {
        color: theme.palette.primary.main
    }
}));

export const StepIndicator = observer(() => {
    const { activeStep } = injectTSDI(SignupStore);
    const { translate } = injectTSDI(I18nStore);

    return (
        <StyledStepper
            activeStep={activeStep}
            connector={<CustomStepConnector />}
        >
            {stepsContent.map((step) => (
                <StyledStep key={step.label}>
                    <StyledStepLabel
                        slots={{ stepIcon: CustomStepIcon }}
                        data-role={step.role}
                    >
                        {translate(step.label)}
                    </StyledStepLabel>
                </StyledStep>
            ))}
        </StyledStepper>
    );
});
